import { format, utcToZonedTime } from "date-fns-tz";

export function getProtoTimestampAsDateString(date: any): string | null {
  const { nanos, seconds } = date;
  if (seconds === 0) {
    return null;
  }
  // @ts-ignore
  const protoDate = new proto.google.protobuf.Timestamp();
  protoDate.setSeconds(seconds);
  protoDate.setNanos(nanos);
  return format(utcToZonedTime(protoDate.toDate(), "UTC"), "dd/MM/yyyy", { timeZone: "UTC" });
}

export function getCurrencyCodeSymbol(currencyCode: string = "EUR") {
  switch (currencyCode.toUpperCase()) {
    case "EUR":
      return "€";
    default:
      return "€";
  }
}
